import { render, staticRenderFns } from "./FlexColumn.vue?vue&type=template&id=e8d26cf4&scoped=true"
import script from "./FlexColumn.vue?vue&type=script&lang=js"
export * from "./FlexColumn.vue?vue&type=script&lang=js"
import style0 from "./FlexColumn.vue?vue&type=style&index=0&id=e8d26cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d26cf4",
  null
  
)

export default component.exports